import React, { useEffect, useState } from "react"
import "./styles.scss"
import Clutch from "../../atoms/Clutch"
const ClutchQuote = ({ text, name, rating, company, position, className }) => {
  const [isDesktop, setIsDesktop] = useState(true)
  useEffect(() => {
    if (window.innerWidth > 1000) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  })
  return (
    <div className={`quote ${className}`}>
      <span className="quote__text">{text}</span>
      <div className="quote__info">
        <span className="quote__name">{name}</span>
        {isDesktop && (
          <span className="quote__position">&nbsp;- {position} -&nbsp;</span>
        )}
        {!isDesktop && <span className="quote__position">{position}</span>}
        <span className="quote__company">{company}</span>
      </div>
      <div className="quote__rating">
        <Clutch rating={rating} />
      </div>
    </div>
  )
}

export default ClutchQuote
